import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50ef7bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 m-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold text-center mb-6" }, "Git Cheatsheet", -1))
const _hoisted_3 = { class: "overflow-x-auto" }
const _hoisted_4 = { class: "table-auto w-full text-left border-collapse border border-gray-400" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-gray-100" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "Command"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "Description")
  ])
], -1))
const _hoisted_6 = { class: "border border-gray-300 p-2" }
const _hoisted_7 = { class: "border border-gray-300 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gitCommands, (description, command) => {
            return (_openBlock(), _createElementBlock("tr", { key: command }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(command), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(description), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}